export const environment = {
  production: true,
  buildId: '3350752885521761',
  configFile: 'config.json',
};
